<div class="container-fluid" [attr.aria-label]="language.questionNavigation">
  <div class="d-flex align-items-center justify-content-between" aria-hidden="true">
    <div [ngClass]="{'pagination-container': showSubmitButtonOnEveryQuestion, 'pagination-container-full': !showSubmitButtonOnEveryQuestion}">
      <ul #pagination class="pagination mb-0 d-flex" role="list" aria-hidden="true">
        <li class="mb-1" *ngFor="let question of questions" [id]="question.questionno"
          [ngClass]="{'active': qno == question.questionno, 'page-item':true}" role="listitem"
          [attr.aria-current]="qno == question.questionno ? 'page' : null" aria-hidden="true">
          <a href="javascript:void(0)" class="page-link h4"
            [ngClass]="{'badge-answered': question.answered && !question.flagged && !question.locked,'badge-unanswered': !question.answered && !question.flagged && !question.locked ,'badge-flagged':question.flagged && !question.locked, 'badge-custom-label': !!question.questionnolabel, 'badge-locked': question.locked }"
            (click)="noclicked(question.questionno)" [attr.aria-label]="language.goToQuestion + ' ' + (question.questionnolabel || question.questionno)" tabindex="-1" aria-hidden="true">{{question.questionnolabel ? question.questionnolabel : question.questionno}}</a>
        </li>
      </ul>
    </div>
    <div *ngIf="showSubmitButtonOnEveryQuestion" class="button-container">
      <button type="button" class="btn btn-danger btn-smaller"  (click)="finishclicked()">
        <span class="btn-text">{{language.finishAndSubmit}}</span>
      </button>
    </div>
  </div>
</div>
